export const BROADCAST_MESSAGE_CHARACTER_LIMIT = 80;
